import { z } from 'zod'

import { zSelect } from 'Lib/zod'

import { FORM_MESSAGES_MAP } from 'Constants/formMessages'

export const reassignDeviceModalFormSchema = z.object({
  employee: zSelect.refine(arg => !!arg?.value, FORM_MESSAGES_MAP.REQUIRED),
})
